import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  CENTRIFUGE_CONNECTION,
  CENTRIFUGE_DISCONNECTION,
  GET_CENTRIFUGE_TOKEN,
  TRACKING_SUBSCRIBE, SEND_TRACKING_REFRESH, SUBSCRIBE, UNSUBSCRIBE,
} from '../actions';
import { AUTHORIZED_MODULE, CENTRIFUGE_MODULE } from '../../../configs/moduleNames';
import { AUTHORIZED_CHECK } from '../../Authorized/actions';
import { SUCCESSFUL } from '../../../configs/actionNames';

import centrifugeConnection from './centrifugeConnection';
import centrifugeDisconnection from './centrifugeDisconnection';
import getCentrifugeToken from './getCentrifugeToken';
import trackingSubscribe from './trackingSubscribe';
import centrifugeUnsubscribe from './centrifugeUnsubscribe';
import sendTrackingRefresh from './sendTrackingRefresh';
import centrifugeSubscribe from './centrifugeSubscribe';

export default function* watchSystem() {
  // yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL, centrifugeConnection);
  yield takeEvery(CENTRIFUGE_MODULE + CENTRIFUGE_CONNECTION, centrifugeConnection);
  yield takeEvery(CENTRIFUGE_MODULE + CENTRIFUGE_DISCONNECTION, centrifugeDisconnection);
  yield takeEvery(CENTRIFUGE_MODULE + GET_CENTRIFUGE_TOKEN, getCentrifugeToken);
  yield takeEvery(CENTRIFUGE_MODULE + TRACKING_SUBSCRIBE, trackingSubscribe);
  yield takeLatest(CENTRIFUGE_MODULE + SUBSCRIBE, centrifugeSubscribe);
  yield takeLatest(CENTRIFUGE_MODULE + UNSUBSCRIBE, centrifugeUnsubscribe);
  yield takeLatest(CENTRIFUGE_MODULE + SEND_TRACKING_REFRESH, sendTrackingRefresh);
}
